import { useTranslation } from "react-i18next";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "../components/ui/alert-dialog";
import { X, Trash2 } from "lucide-react";

export default function DeleteConfirmDialog({ open, onOpenChange, title, description, onConfirm }) {
  const { t } = useTranslation();
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="font-heading text-slate-900">{title || "Confirmar exclusão"}</AlertDialogTitle>
          <AlertDialogDescription className="text-slate-500">
            {description || "Tem certeza que deseja excluir este registro? Esta ação pode ser desfeita."}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="text-slate-600"><X className="w-4 h-4 mr-2" />{t("common.cancel")}</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} className="bg-rose-600 hover:bg-rose-700 text-white">
            <Trash2 className="w-4 h-4 mr-2" />Excluir
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
